import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { type Genre, type ScreenType } from '@tmdb-graphql-api/schema/types';
import { type ReactNode, useEffect } from 'react';
import { mapScreenTypeToDiscoverTypeRoute } from '#helpers/enumMappers.ts';
import { type MenuItem } from './types.ts';

export type MainMenuData = {
  genres: Genre[];
};

export type MenuItemsQueryProps = {
  children: (renderProps: { items: MenuItem[] }) => ReactNode | ReactNode[];
  type: ScreenType;
};

const formatMenuItems = (data: MainMenuData | null | undefined, type: ScreenType) => {
  return data
    ? data.genres.map(genre => ({
        href: `/discover/${mapScreenTypeToDiscoverTypeRoute(type)}?discoverFilters=%7B"withGenres"%3A"${String(genre.id)}"%7D`,
        id: genre.id,
        label: genre.name,
      }))
    : [];
};

const GET_MAIN_MENU = "query GetGenres(\n  $screenType: ScreenType!\n) {\n  genres(screenType: $screenType) {\n    name\n  }\n}\n";

export const MenuItemsQuery = ({ children, type }: MenuItemsQueryProps) => {
  const { execute, loading, result } = useQuery<MainMenuData>(GET_MAIN_MENU, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { screenType: type } }, { data: { initiator: 'MainMenu' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  const items = formatMenuItems(result?.data, type);

  if (!loading && items.length === 0) {
    return;
  }

  return children({ items });
};
